module.exports = __webpack_public_path__ + "img/nodata.b16b54b7.png";